import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import SearchResultItem from 'components/ui/SearchResultItem'
import { t } from 'ttag'
import SearchResultTitle from 'components/ui/SearchResultTitle'
import SearchResultDescription from 'components/ui/SearchResultDescription'
import SearchResultListing from 'components/ui/SearchResultListing'
import SearchResultContent from 'components/ui/SearchResultContent'
import Button from 'components/ui/Button'
import { useDispatch, useSelector } from 'react-redux'
import FilterSelection from 'components/FilterSelection'
import { downloadDocumentFile, toggleDocumentsVisible } from 'store/actions/search'
import SearchResult from 'components/ui/SearchResult'
import CustomPagination from 'components/CustomPagination'
import ElementSave from 'components/ElementSave'
import SearchResultSelectedFilters from 'components/ui/SearchResultSelectedFilters'
import ExtendedSearchResultInfo from 'components/ui/ExtendedSearchResultInfo'
import InfoCol from 'components/ui/InfoCol'
import ResultInfo from 'components/ui/ResultInfo'
import SearchFooter from 'components/ui/SearchFooter'
import ChangeOrder from 'components/ChangeOrder'
import ResultActions from 'components/ui/ResultActions'
import ResultAction from 'components/ui/ResultAction'
import ResultActionIcon from 'components/ui/ResultActionIcon'
import ResultUrlContainer from 'components/ui/ResultUrlContainer'
import LoadingSpinner from 'components/ui/LoadingSpinner'
import { getResultUrl } from 'util/hash'
import {
  PROJECTS_RESULTS_PER_PAGE,
  IS_SEARCH_REPRESANTIVENESS_DISABLED
} from 'store/constants/constants'
import breakpoints from 'assets/stylesheet'
import PartnersMap from 'components/PartnersMap'
import SpinnerContainer from 'components/ui/SpinnerContainer'
import { show } from 'redux-modal'

const StyledButton = styled(Button)`
  padding: 6px 16px;
  margin-top: 10px;
  width: auto;
  font-weight: normal;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 14px !important;
  }
`

const LocationResultsTitle = styled.h2`
  color: #4a4a4a !important;
  font-size: 22px !important;
  margin-top: 10px !important;
  margin-bottom: 15px !important;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 18px !important;
  }
`
const Link = styled.a`
  color: #003399;
  text-decoration: none;
`
const AttachmentSearchResultContent = styled(SearchResultContent)`
  padding: 12px;
`
const AttachmentContainer = styled.div`
  padding: 5px 0;
`
const AttachmentAction = styled.a`
  border-radius: 2px;
  background-color: #a6a6a6;
  text-decoration: none;
  color: #0f0f0f;
  font-family: 'Open Sans';
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  padding: 5px;
  cursor: pointer;
  margin-right: 27px;
  margin-top: 5px;
  display: inline-block;
`
const ResultTitle = styled.span`
  color: #003399;
  font-weight: bold;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  padding: 2px 0;
  padding-right: 21px;
`
const AttachmentResultTitle = styled(ResultTitle)`
  color: #4a4a4a;
`
const ResultSubTitle = styled.div`
  color: #4a4a4a;
  font-weight: bold;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 0;
`
const AttachmentResultSubTitle = styled(ResultSubTitle)`
  color: #003399;
`
const ResultText = styled.div`
  color: #4a4a4a;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const Loading = styled.div`
  position: relative !important;
  margin-top: 50px;
`
const ErrorText = styled.p`
  color: #f31100;
`
const AttachmentIcon = styled.i`
  font-size: 14px;
  color: #0f0f0f;
  margin-left: 20px;
  cursor: pointer;
`
const ToggleContentLabel = styled.b`
  display: block;
  padding: 10px 0 4px 0;
`
const ProjectSearchResultContainer = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    display: block;
  }
`
const ProjectSearchResultListingContainer = styled.div`
  width: 50%;
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    width: 100%;
  }
`
const ResultMapContainer = styled.div`
  width: 50%;
  position: relative;
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    width: 100%;
  }
`
const ProjectSearchResultListing = styled(SearchResultListing)`
  width: auto;
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    display: block;
  }
`
const ProjectSearchResultItem = styled.li`
  width: 100%;
  @media (min-width: ${breakpoints.contentWrapLarge}) {
    width: 50%;
  }
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    width: 100%;
  }
`
const LanguageList = styled.ul`
  padding-left: 18px;
  list-style-type: disc;
`
const InfoLink = styled.a`
  margin-left: 10px;
  cursor: pointer;
`
const CriteriaInfoIcon = styled.i`
  font-size: 16px;
  margin: 0px 0px 0px 10px;
  cursor: pointer;
  font-family: 'Font Awesome 5 Pro';
  font-style: normal;
  font-weight: 400;
  color: rgba(0, 51, 153, 0.5);
  display: inline-flex !important;
`
/*
const handleProjectTranslation = (project, field) => {
  let value
  let languageIndex = 0
  if ('en' in project.translations && project.translations.en[field]) {
    value = project.translations.en[field]
  } else {
    while (!value && project.translations[Object.keys(project.translations)[languageIndex]]) {
      value = project.translations[Object.keys(project.translations)[languageIndex]][field]
      languageIndex += 1
    }
  }

  return value
}*/

// eslint-disable-next-line no-useless-escape
const handleFileName = path => path.replace(/^.*[\\\/]/, '')

const getAttachmentTitle = attachment => {
  if (attachment.attachment_type === 'file') {
    return attachment.name
  }
  return attachment.name ? attachment.name : attachment.link_url
}

function AnimatedNumber({ value }) {
  const [display, setDisplay] = useState(null)

  useEffect(() => {
    if (value == null) {
      setDisplay(null)
      return
    }
    let frame = 0
    const totalFrames = 40
    const startValue = 0
    const interval = setInterval(() => {
      frame++
      if (frame <= totalFrames) {
        const progress = frame / totalFrames
        const nextValue = Math.floor(startValue + progress * value)
        setDisplay(nextValue)
      } else {
        setDisplay(value)
        clearInterval(interval)
      }
    }, 30)
    return () => clearInterval(interval)
  }, [value])

  if (display == null) {
    return <span className="representativity-value loading">--%</span>
  }
  return <span className="representativity-value">{display}%</span>
}

AnimatedNumber.propTypes = {
  value: PropTypes.number
}

function ProjectSearchResults({
  selectedFilters,
  searchResults: {
    results = [],
    representativity,
    count,
    related_count: relatedCount,
    current,
    next,
    previous,
    total_pages: totalPages
  },
  documentSearchResults: {
    results: documentResults,
    count: documentCount,
    current: documentCurrent,
    next: documentNext,
    previous: documentPrevious,
    total_pages: documentTotalPages
  },
  orderby,
  //  lastUpdate,
  isPending,
  error,
  isSidebarVisible,
  reduced,
  onPageChange,
  orderChanged,
  hasLocationPermission,
  hasLocationSearchResults,
  onExportToExcel,
  currentFilters,
  onGetResultUrl,
  resultHash,
  onMapImageDownload,
  isMapDownloadPending,
  isExcelExportPending,
  isExcelDocumentPending
}) {
  const dispatch = useDispatch()
  const search = useSelector(state => state.search)
  const [showTableSaveModal, setShowTableSaveModal] = useState(false)
  const { isDocumentsVisible, isDocumentsPending } = search
  const cookies = document.cookie.split('; ')
  const authenticated = cookies.some(c => c.startsWith('keep_auth_token'))
  const [state, setState] = useState({ orderby: orderby })
  const [filterLength, setFilterLength] = useState(0)
  //  eslint-disable-next-line
  const [sectionsContainer, setSectionsContainer] = useState(
    document.getElementById('summary-options')
  )
  /*useEffect(() => {
    // React advises to declare the async function directly inside useEffect
    async function getLastUpdate() {
      const response = await Get('/api/programme/data_last_updated/');
      const data = await response;
      setState({lastUpdate: data.updated})
    };

    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    if (!lastUpdate) {
        getLastUpdate();
    }
  }, []);*/
  useEffect(() => {
    const updateSectionsContainer = () => {
      const element = document.getElementById('summary-options')
      countFilters(element)
      setSectionsContainer(element)
    }
    updateSectionsContainer()
  }, [])

  const countFilters = filterSections => {
    return new Promise(resolve => {
      setTimeout(() => {
        const filterLength = filterSections
          ? filterSections.querySelectorAll('.filtering').length
          : 0
        const col = filterSections ? filterSections.querySelectorAll('.summary') : [null]
        if (col[0]) {
          if (filterLength < 1) {
            col[0].classList.add('hide')
          } else {
            col[0].classList.add('show')
          }
        }
        setFilterLength(filterLength)
        resolve(filterLength) // Resolve the Promise with the filter length
      }, 10) // Adjust timeout duration if necessary
    })
  }

  useEffect(() => {
    const filterSections = document.querySelector('.filter-sections')
    countFilters(filterSections).then(length => {
      setFilterLength(length) // Update state with the filter length
    })
  }, [sectionsContainer])

  useEffect(() => {
    countFilters(sectionsContainer)
  }, [sectionsContainer])

  const updateOrder = i => {
    orderChanged(i)
    setState({
      orderby: i
    })
  }

  const handleFileDownload = result => {
    dispatch(
      downloadDocumentFile({
        id: result.id,
        fileName: handleFileName(result.file)
      })
    )
  }

  const handleDocumentExport = data => {
    onExportToExcel(data, true, 'doc')
  }

  const getAttachmentToggleContent = result => (
    <div>
      {result.type ? (
        <div>
          <ToggleContentLabel>{t`Type:`}</ToggleContentLabel>
          {result.type}
        </div>
      ) : (
        ''
      )}
      {result.description ? (
        <div>
          <ToggleContentLabel>{t`Description:`}</ToggleContentLabel>
          {result.description}
        </div>
      ) : (
        ''
      )}
      {result.data_source ? (
        <div>
          <ToggleContentLabel>{t`Data source:`}</ToggleContentLabel>
          {result.data_source}
        </div>
      ) : (
        ''
      )}
      {result.publication_date ? (
        <div>
          <ToggleContentLabel>{t`Publication date:`}</ToggleContentLabel>
          {result.publication_date}
        </div>
      ) : (
        ''
      )}
      {result.document_date ? (
        <div>
          <ToggleContentLabel>{t`Document date:`}</ToggleContentLabel>
          {result.document_date}
        </div>
      ) : (
        ''
      )}
      {result.languages && result.languages.length > 0 ? (
        <ToggleContentLabel>{t`Languages:`}</ToggleContentLabel>
      ) : (
        ''
      )}
      {result.languages && result.languages.length > 0 ? (
        <LanguageList>
          {result.languages.map(lan => (
            <li key={lan}>{lan}</li>
          ))}
        </LanguageList>
      ) : (
        ''
      )}
    </div>
  )

  let resultsComponent
  const loading =
    (isDocumentsVisible && (isDocumentsPending || isPending)) || (!isDocumentsVisible && isPending)

  if (isDocumentsVisible) {
    if (documentResults.length === 0) {
      resultsComponent = <div className="no-results">{t`No results found`}</div>
    } else {
      resultsComponent = (
        <>
          <SearchResultListing>
            {documentResults.map(result => (
              <SearchResultItem key={result.id} className="list-document">
                <AttachmentSearchResultContent>
                  <SearchResult
                    toggleContent={getAttachmentToggleContent(result)}
                    truncateContent={false}
                  >
                    <AttachmentContainer className="item-shaded document">
                      <AttachmentResultTitle>{`${getAttachmentTitle(result)} (${
                        result.type
                      })`}</AttachmentResultTitle>
                      <Link target="_blank" href={`/projects/${result.project}`}>
                        <AttachmentResultSubTitle>{result.acronym}</AttachmentResultSubTitle>
                      </Link>
                      <ResultText>{result.programme_title}</ResultText>
                      <div>
                        {result.attachment_type === 'file' ? (
                          <AttachmentAction
                            onClick={() => handleFileDownload(result)}
                            className="attachment-icon"
                          >
                            {t`Download`} <AttachmentIcon className="far fa-file-download" />
                          </AttachmentAction>
                        ) : (
                          <AttachmentAction
                            target="_blank"
                            rel="noopener noreferrer"
                            href={result.link_url}
                            className="attachment-icon not-document"
                          >
                            {t`Visit`} <AttachmentIcon className="far fa-external-link" />
                          </AttachmentAction>
                        )}
                      </div>
                    </AttachmentContainer>
                  </SearchResult>
                </AttachmentSearchResultContent>
              </SearchResultItem>
            ))}
          </SearchResultListing>
          {documentCount > PROJECTS_RESULTS_PER_PAGE && (
            <SearchFooter>
              <CustomPagination
                onPageChange={data => onPageChange(data, true)}
                count={documentCount}
                current={documentCurrent}
                next={documentNext}
                previous={documentPrevious}
                totalPages={documentTotalPages}
                section={'projects'}
              />
            </SearchFooter>
          )}
        </>
      )
    }
  } else if (results.length === 0) {
    resultsComponent = <div className="no-results">{t`No results found.`}</div>
  } else {
    const urlParams = new URLSearchParams(window.location.search)
    const hideResults = urlParams.get('hide-results')
    resultsComponent = (
      <>
        <ChangeOrder
          orderby={orderby === '' ? '' : state.orderby}
          orderChanged={i => updateOrder(i)}
          type="projects"
        />
        <ProjectSearchResultContainer>
          <ProjectSearchResultListingContainer>
            {!hideResults && (
              <ProjectSearchResultListing>
                {results.map(result => (
                  <ProjectSearchResultItem key={result.id}>
                    <Link target="_blank" href={`/projects/${result.id}`} className="item-shaded">
                      <SearchResultContent>
                        <SearchResult
                          toggleContent={false} /*toggleContent={getProjectToggleContent(result)}*/
                        >
                          <div className="text-container">
                            <ResultSubTitle>
                              <ResultTitle title={result.acronym}>{result.acronym}</ResultTitle>
                              {/*<ResultTitle className="grey" title={handleProjectTranslation(result, 'name')}>{handleProjectTranslation(result, 'name')}</ResultTitle> */}
                              <ResultTitle className="grey" title={result.programme.title}>
                                {result.programme.title}
                              </ResultTitle>
                            </ResultSubTitle>
                            <div className="themes">
                              {result.themes.map((theme, i) => (
                                <span key={i} title={theme.title}>
                                  {i > 0 && ', '}
                                  {theme.title}
                                </span>
                              ))}
                            </div>
                            {(result.small_project || result.technical_assistance) && (
                              <div className="project-summary">
                                {result.small_project && (
                                  <div className="small-project">Small project</div>
                                )}
                                {result.technical_assistance && (
                                  <div className="technical-assistance">
                                    Technical assistance project
                                  </div>
                                )}
                              </div>
                            )}
                            {/* result.programme && <ResultText title={result.programme.title}>{result.programme.title}</ResultText> */}
                          </div>
                        </SearchResult>
                      </SearchResultContent>
                      <div className="read-more">
                        <i className="fa fa-chevron-right"></i>
                      </div>
                    </Link>
                  </ProjectSearchResultItem>
                ))}
              </ProjectSearchResultListing>
            )}
            {count > PROJECTS_RESULTS_PER_PAGE && (
              <SearchFooter>
                <CustomPagination
                  onPageChange={data =>
                    onPageChange(data, false, orderby === '' ? '' : state.orderby)
                  }
                  count={count}
                  current={current}
                  next={next}
                  previous={previous}
                  totalPages={totalPages}
                  section={'projects'}
                />
              </SearchFooter>
            )}
          </ProjectSearchResultListingContainer>
          <ResultMapContainer>
            <PartnersMap isSidebarVisible={isSidebarVisible} />
          </ResultMapContainer>
        </ProjectSearchResultContainer>
        {
          <InfoCol>
            <SearchResultDescription style={{ marginTop: '50px' }}>{t`
              All the project-partner-call data in keep.eu is the responsibility of the programmes financing
              those projects, with the exception of the information of European Union macro-regional strategies,
              which is collected from these strategies' documents.
          `}</SearchResultDescription>
          </InfoCol>
        }
      </>
    )
  }

  if (error) {
    resultsComponent = <ErrorText>{t`An unexpected error occurred.`}</ErrorText>
  }

  const urlParams = new URLSearchParams(window.location.search)
  const hideSearch = urlParams.get('hide-search')
  if (hideSearch) {
    return (
      <ResultMapContainer>
        <PartnersMap isSidebarVisible={isSidebarVisible} />
      </ResultMapContainer>
    )
  }

  return (
    <>
      <SearchResultTitle>
        <h1>{t`Search results: Projects and their documents`}</h1>
        {
          <StyledButton
            id="pd_switch_to"
            onClick={() =>
              dispatch(
                toggleDocumentsVisible({
                  isDocumentsVisible: !isDocumentsVisible
                })
              )
            }
          >
            {/*(isDocumentsVisible ? t`Switch to project view` : t`Switch to document view`)*/}
          </StyledButton>
        }
      </SearchResultTitle>
      {
        <>
          <ExtendedSearchResultInfo>
            {isDocumentsVisible && (
              <InfoCol>
                <SearchResultDescription>{t`
              Click on any of the buttons 'Download' or 'Visit' to get to the required documents.
              `}</SearchResultDescription>
              </InfoCol>
            )}
          </ExtendedSearchResultInfo>
        </>
      }
      <>
        <SearchResultTitle>
          {/*(<StyledButton 
              onClick={() =>
                dispatch(
                  toggleDocumentsVisible({
                    isDocumentsVisible: !isDocumentsVisible
                  })
                )
              }
            >
              {isDocumentsVisible ? t`Switch to project view` : t`Switch to document view`}
            </StyledButton>)*/}
        </SearchResultTitle>
        {results.length > 0 && !isDocumentsVisible && (
          <div className="fixed-buttons">
            <ResultAction onClick={onExportToExcel} id="pd_to_excel">
              {isExcelExportPending ? (
                <SpinnerContainer>
                  <LoadingSpinner showText={false} />
                </SpinnerContainer>
              ) : (
                <ResultActionIcon className="far fa-file-excel" />
              )}
              <div className="export-texts">
                <span>
                  {isExcelExportPending ? 'Exporting ' : 'Export '}
                  {t`all project data from your search results to Excel`}
                </span>
                <span className="export-subtitle">
                  {t`Please allow extended time for your export to fully download`}
                </span>
              </div>
            </ResultAction>
            {documentResults.length > 0 && (
              <ResultAction onClick={handleDocumentExport} id="d_to_excel">
                {isExcelDocumentPending ? (
                  <SpinnerContainer>
                    <LoadingSpinner showText={false} />
                  </SpinnerContainer>
                ) : (
                  <ResultActionIcon className="far fa-file-excel" />
                )}
                <div className="export-texts">
                  <span>
                    {isExcelDocumentPending ? 'Exporting ' : 'Export '}
                    {t`list of all documents and their links from your search results to Excel`}
                  </span>
                  <span className="export-subtitle">
                    {t`Please allow extended time for your export to fully download`}
                  </span>
                </div>
              </ResultAction>
            )}
          </div>
        )}
        <ExtendedSearchResultInfo>
          <ResultActions>
            {results.length > 0 && !isDocumentsVisible && (
              <>
                <ResultAction onClick={onMapImageDownload} id="pd_download_map">
                  {isMapDownloadPending ? t`Downloading map image` : t`Download map image`}
                  {isMapDownloadPending ? (
                    <SpinnerContainer>
                      <LoadingSpinner showText={false} />
                    </SpinnerContainer>
                  ) : (
                    <ResultActionIcon className="far fa-file-download" />
                  )}
                </ResultAction>
              </>
            )}

            {documentResults.length > 0 && isDocumentsVisible && (
              <ResultAction onClick={handleDocumentExport} id="d_to_excel">
                {isExcelExportPending ? 'Exporting to Excel' : 'Export to Excel '}
                {isExcelExportPending ? (
                  <SpinnerContainer>
                    <LoadingSpinner showText={false} />
                  </SpinnerContainer>
                ) : (
                  <ResultActionIcon className="far fa-file-excel" />
                )}
              </ResultAction>
            )}
            <>
              {resultHash === '' ? (
                <ResultAction onClick={onGetResultUrl} id="pd_get_result_url">
                  {t`Copy page URL`} <ResultActionIcon className="far fa-external-link" />
                </ResultAction>
              ) : (
                <>
                  <ResultUrlContainer
                    onClick={e => e.target.select()}
                    defaultValue={getResultUrl(resultHash)}
                  />
                  <InfoLink
                    target="_blank"
                    onClick={async () => {
                      const data = await fetch(
                        `/wp-json/wp/v2/pages?slug=url-get-results-url-how-to-shorten-the-urls`
                      )
                      const jsonData = await data.json()
                      const msg = jsonData[0].content.rendered
                      dispatch(show('infoModal', { message: msg }))
                    }}
                  >{t`How to shorten the URLs?`}</InfoLink>
                </>
              )}
            </>
            {authenticated && (
              <ResultAction
                onClick={() => setShowTableSaveModal(true)}
              >{t`Save table`}</ResultAction>
            )}
          </ResultActions>
          <InfoCol>
            <div className="evening full-width">
              <div className="col results-summary">
                {!isPending && <h4 className="moderate">Results summary</h4>}
                {!isPending && !error && (
                  <ResultInfo>
                    <div className="results-tip">
                      <div className="tipped">
                        <span>{t`${count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`}</span>{' '}
                        {t`projects`}
                      </div>
                      <div className="pipe"></div>
                      <div className="tipped">
                        <span>{t`${(relatedCount.docs || 0)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`}</span>{' '}
                        {t`documents`}
                      </div>
                      <div className="pipe"></div>
                      <div className="tipped">
                        <span>{t`${(relatedCount.partners || 0)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`}</span>{' '}
                        {t`partners`}
                      </div>
                      <div className="pipe"></div>
                      <div className="tipped">
                        <span>{t`${(relatedCount.partnerships || 0)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`}</span>{' '}
                        {t`partnerships`}
                      </div>
                      <div className="pipe"></div>
                      <div className="tipped">
                        <span>{t`${(relatedCount.programmes || 0)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`}</span>{' '}
                        {t`programmes`}
                      </div>
                    </div>
                  </ResultInfo>
                )}
              </div>
              {!isPending && !IS_SEARCH_REPRESANTIVENESS_DISABLED && (
                <div className="col fixed-width-results">
                  <h4 className="moderate">
                    {t`Results coverage`}
                    <CriteriaInfoIcon
                      className="far fa-question-circle"
                      onClick={() => {
                        const coverageMessage = `
                        <h2>Results coverage</h2>
                        <p>Share of projects and project partners available in keep.eu compared to the estimated totals for the programmes represented in these results.</p>
                        <p>Estimates are based on programme-level data and the most recent updates or confirmations (latest: ${representativity && representativity.last_update ? new Date(representativity.last_update).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : 'N/A'}). Coverage varies across programmes. Programmes are normally expected to provide their updated project-partner data every four months or whenever newly contracted projects become available.</p>
                        <p>To learn more about how coverage is calculated and what it represents, please refer to <a href="https://keep.eu/representativeness/" rel="noreferrer" target="_blank">Representativeness</a>.</p>
                      `
                        dispatch(show('infoModal', { message: coverageMessage }))
                      }}
                      title="Learn more about coverage"
                    />
                  </h4>
                  <div className="results-tip">
                    <AnimatedNumber
                      value={representativity && representativity.percentage_projects_in_keep}
                    />
                    {t`of projects and`}{' '}
                    <AnimatedNumber
                      value={representativity && representativity.percentage_partnerships_in_keep}
                    />
                    {t`of project partners in keep.eu`}
                  </div>
                </div>
              )}
              <div className="break"></div>
              {!isPending && (
              <div id="summary-options" className="evening new-line">
                {(isSidebarVisible || reduced) && (
                  <SearchResultSelectedFilters
                    className={`col summary ${filterLength > 0 ? 'show' : 'hide'}`}
                  >
                    <h4 id="summary-search-options">
                      Summary of search options{' '}
                      {filterLength > 0 && <span>{'(' + filterLength + ')'}</span>}
                    </h4>
                    <div className="selected-container">
                      <FilterSelection
                        selectedFilters={selectedFilters?.projects}
                        currentFilters={currentFilters}
                        onFilterCountChange={setFilterLength}
                      />
                    </div>
                  </SearchResultSelectedFilters>
                )}
                {/* !isPending && !error && (
                <div className="col show">
                  <h4>Summary of search results</h4>
                  <ResultInfo>
                    <div className="results-tip">
                      <div className="tipped">{t`${count} projects`}</div>
                      <div className="tipped">{t`${(relatedCount.docs || 0)
                        .toString()
                        .replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          " "
                        )} documents`}</div>
                      <div className="tipped">{t`${(
                        relatedCount.partners || 0
                      )
                        .toString()
                        .replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          " "
                        )} partners`}</div>
                      <div className="tipped">{t`${(
                        relatedCount.partnerships || 0
                      )
                        .toString()
                        .replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          " "
                        )} partnerships`}</div>
                      <div className="tipped">{t`${(
                        relatedCount.programmes || 0
                      )
                        .toString()
                        .replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          " "
                        )} programmes`}</div>
                    </div>
                  </ResultInfo>
                </div>-->
                        ) */}
              </div>
            )}
            </div>
          </InfoCol>
          {isDocumentsVisible ? (
            <InfoCol>
              <SearchResultDescription>{t`
              Click on any of the buttons 'Download' or 'Visit' to get to the required documents.
              `}</SearchResultDescription>
            </InfoCol>
          ) : (
            !isPending && !error && ''
            /*<InfoCol>
                  <SearchResultDescription>{t`
              Click on any entry below to get to the full data on a project and its partners,
              or export the table below to Excel and get aggregated data on all projects, partners and calls.
              `}</SearchResultDescription>
                </InfoCol> */
          )}
        </ExtendedSearchResultInfo>
      </>
      {loading ? (
        <Loading>
          <LoadingSpinner showText />
        </Loading>
      ) : (
        <>
          {hasLocationPermission && hasLocationSearchResults && !isDocumentsVisible && (
            <LocationResultsTitle>{t`Projects near you`}</LocationResultsTitle>
          )}
          <ElementSave
            type="table"
            show={showTableSaveModal}
            isSidebarVisible={isSidebarVisible}
            closeElementSave={() => setShowTableSaveModal(false)}
          />
          {resultsComponent}
        </>
      )}
    </>
  )
}

ProjectSearchResults.propTypes = {
  selectedFilters: PropTypes.object,
  searchResults: PropTypes.shape({
    results: PropTypes.array,
    representativity: PropTypes.object,
    count: PropTypes.number,
    current: PropTypes.number,
    related_count: PropTypes.object,
    next: PropTypes.string,
    previous: PropTypes.string,
    total_pages: PropTypes.number
  }),
  documentSearchResults: PropTypes.shape({
    results: PropTypes.array,
    count: PropTypes.number,
    current: PropTypes.number,
    related_count: PropTypes.object,
    next: PropTypes.string,
    previous: PropTypes.string,
    total_pages: PropTypes.number
  }),
  orderby: PropTypes.string,
  lastUpdate: PropTypes.string,
  isPending: PropTypes.bool,
  error: PropTypes.bool,
  isSidebarVisible: PropTypes.bool,
  reduced: PropTypes.bool,
  onPageChange: PropTypes.func,
  updateSorting: PropTypes.func,
  orderChanged: PropTypes.func,
  hasLocationPermission: PropTypes.bool,
  hasLocationSearchResults: PropTypes.bool,
  onExportToExcel: PropTypes.func,
  currentFilters: PropTypes.array,
  onGetResultUrl: PropTypes.func,
  resultHash: PropTypes.string,
  onMapImageDownload: PropTypes.func,
  isMapDownloadPending: PropTypes.bool,
  isExcelExportPending: PropTypes.bool,
  isExcelDocumentPending: PropTypes.bool,
  sectionNumber: PropTypes.number
}

export default ProjectSearchResults
